import React, { useState, useEffect } from "react";
import AccordionItem from "./AccordionItem";
import { Container } from "react-bootstrap";
import { useHttpClient } from "../../hooks/http-hook";
import { useAuth } from "../../Context/AuthContext";
import { useTranslation } from "react-i18next"; // Importer useTranslation

const ModuleAccordion = (props) => {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const { authData } = useAuth();
  const [modulesProgress, setModulesProgress] = useState([]);

  useEffect(() => {
    const fetchModulesProgress = async () => {
      try {
        if (!props.program._id || !authData.userId) return;

        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/user-program-progress/all-modules-progress/${props.program._id}?user=${authData.userId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
          }
        );

        if (!response.ok) {
          throw new Error(t("fetch_progress_error"));
        }

        const data = await response.json();
        setModulesProgress(data);
      } catch (error) {
        console.error(t("fetch_progress_error"), error);
      }
    };

    fetchModulesProgress();
  }, [props.program._id, authData.userId, t]);

  const getModuleProgress = (moduleId) => {
    const moduleData = modulesProgress.find(
      (item) => item.moduleId === moduleId
    );
    return moduleData ? moduleData.progress : 0;
  };

  return (
    <div>
      <Container className="shadow mt-5 p-3 rounded-4">
        <div className="container mt-4">
          {props.program.modules.length === 0 ? (
            <p className="text-center fw-bold">{t("no_modules_in_program")}</p>
          ) : (
            props.program.modules.map((module) => {
              if (
                (module.is_visible === false &&
                  props.program.created_by._id !== authData.userId) ||
                module.is_deleted === true
              ) {
                return null;
              }
              return (
                <AccordionItem
                  key={module._id}
                  title={module.title}
                  description={module.description}
                  is_visible={module.is_visible}
                  _id={module._id}
                  program_id={props.program._id}
                  progress={getModuleProgress(module._id)}
                >
                  {module.sections.length === 0 ? (
                    <p className="text-center fw-bold">
                      {t("no_sections_in_module")}
                    </p>
                  ) : (
                    module.sections.map((section) => {
                      return (
                        <AccordionItem
                          key={section._id}
                          title={section.title}
                          isSection={true}
                        >
                          {section.lessons.length === 0 ? (
                            <p className="text-center fw-bold">
                              {t("no_lessons_in_section")}
                            </p>
                          ) : (
                            section.lessons.map((lesson) => {
                              return (
                                <AccordionItem
                                  key={lesson._id}
                                  title={lesson.title}
                                  isLesson={true}
                                  lessonId={lesson._id}
                                  moduleId={module._id}
                                  sectionId={section._id}
                                  program_id={props.program._id}
                                />
                              );
                            })
                          )}
                        </AccordionItem>
                      );
                    })
                  )}
                </AccordionItem>
              );
            })
          )}
        </div>
      </Container>
    </div>
  );
};

export default ModuleAccordion;
